import { Modal } from "antd";
import React, {useState } from "react";
import { useSelector } from "react-redux";
import { toastInformation } from "../../../../base/callService/common";
import { cancelMeetingUuid, deleteMeetingTemplate, deleteMeetingUuid, getMeetingByDate, getTemplateList, savedTemplateTitle } from "../../../../base/meetingService/apiService";
import { storeWindowState,storeTemplateList }
  from "../../../../base/meetingService/meetingStoreServices";
import store from "../../../../context/store/store";
import { LoginState } from "../../../../models/model";
import { URButton } from "../../../../shared/widgets/button";
import { URInput } from "../../../../shared/widgets/input";
import MeetingDetailsLeft from "../meetingDetailsLeft";
import MeetingDetailsRight from "../meetingDetailsRight";
import MeetingDetailsTop from "../meetingDetailsTop";
import styles from "./meetingDetails.module.scss";
import moment from "moment";
import { useHistory } from "react-router-dom";
export default function MeetingDetailsScreen() {


  let { meetingReducer }: any = useSelector((state: any) => state);
  let { detailPage,currentWindowState,templateDetailPage,getTemplateListInput } = meetingReducer;
  const[scrollValue , setScrollValue] = useState<any>(false)
  let {userdetails}:LoginState = store.getState().loginReducer;
  let history = useHistory();
  type meetDetailState = {
    isCancelModal: boolean;
    isDeleteModal: boolean;
    useTemplateModal: boolean;
    deleteTemplateModal:boolean;
    inputText: string;
  };
  const [getData, setData] = useState<meetDetailState>({
    isCancelModal:false,isDeleteModal:false,useTemplateModal: false,
    inputText: '',deleteTemplateModal:false
  });
    let previousMeetingArray: any = ['Completed', 'Missed','Cancelled','Ongoing Meeting'];
  const editMeeting = () => {
    storeWindowState("editMeeting");
  };

  const cancelMeeting = () => {
    setData({...getData,isCancelModal:true});
  };
  const cancelMeetingConfirm = () => {
    cancelMeetingUuid(detailPage.uuid, detailPage).then((res: any) => {
      if (res?.statusCode === 200){
        setData({ ...getData, isCancelModal: false });
        toastInformation(res.message,"success")
      }
      else {
         setData({ ...getData, isCancelModal: false });
        toastInformation(res?.message,"failed")
      }

    });
  };

  const closeModal = () => {
    setData({...getData,isCancelModal:false,isDeleteModal:false,useTemplateModal:false});
  };

  const deleteMeeting = () => {
    setData({...getData,isDeleteModal:true});
  };

  const deleteMeetingConfirm = () => {
    let uuidArray:any=[];
    uuidArray.push(detailPage.uuid);
    deleteMeetingUuid(uuidArray).then((res: any) => {
      if(res?.statusCode === 200){
        setData({ ...getData, isDeleteModal: false });
        toastInformation("Meeting deleted successfully","success")
        const curDate = new Date();
getMeetingByDate(moment(curDate).format("YYYY-MM-DD"));
      }
    });
    setData({ ...getData, isDeleteModal: false });
    history.push("/meeting")
    storeWindowState("mainPage");
  };

  const useThisTemplate = () => {
    storeWindowState("useTemplate");
  };

  const saveAsTemplate = () => {
    setData({ ...getData, useTemplateModal: true,inputText:detailPage.title });
  }

  const enterTitle = (e:any) => {
    setData({...getData,inputText:e.target.value});
  };

  const saveAsTemplateConfirm = () => {
    
    savedTemplateTitle(detailPage.uuid, getData.inputText).then((res: any) => {
      if(res?.statusCode === 200){
        setData({ ...getData, useTemplateModal: false });
             storeTemplateList([]);
  let input:any= {};
    input.isDate = -1;
    input.isTitle = -1;
    let data: any = {};
    data.offset = 0;
    data.limit = 10;
    data.sort = -1;
    data.sortType = "date";
    getTemplateList(data,input);
    toastInformation("Meeting Saved As Template Successfully");
      }
    });
  };

  const deleteTemplate=()=>{
    setData({ ...getData, deleteTemplateModal: true });
  }
  const deleteTemplateConfirm = () => {
    deleteMeetingTemplate(templateDetailPage.template_id).then((res: any) => {
      if (res?.statusCode === 200) {
    let input:any= {};
    input.isDate = -1;
    input.isTitle = -1;
    let data: any = {};
    data.offset = 0;
    data.limit = 10;
    data.sort = -1;
    data.sortType = "date";
    getTemplateList(data, input);
    storeWindowState("mainPage");
    toastInformation(res.message, "success");
      }
    }); 
  }

     
  const handleScroll = (e:any) => {
   
    if(e.target.scrollTop>=240){
      setScrollValue(true)
    }else{
      setScrollValue(false)
    }
    // console.log('offsetHeight: ', e.target.offsetHeight);
    
    // var edit:any = document.getElementById("fixed")
    // edit.add.className = 'fixedTop';
  }


  return (
    <>
      <div className={styles.meetingDetailsScreen}>
        <MeetingDetailsTop />
        <div className={scrollValue?`fixedTop ${styles.detailsSection}`:styles.detailsSection} onScroll={handleScroll}>
          <MeetingDetailsLeft scrollValue={scrollValue}/>
          {/* <MeetingDetailsRight /> */}
        </div>
        <div className={`"scroller" ${styles.templateBottom} ${styles.editRightbtm}`}>
          {currentWindowState === "meetingDetails" && <>
            {(detailPage.status === "Start") && <div className={styles.upongingconsec}>
              <div>
              {(userdetails.sip_login_id === detailPage.sip_id) && (detailPage.status === "Start") &&
                  <>
                  {(detailPage.status === "Start" || detailPage.status === "Ongoing Meeting") && <>{userdetails.sip_login_id === detailPage.sip_id && <URButton className='urButton buttonWhite buttonMd right8' name={"Save as Template"} onClick={saveAsTemplate}></URButton>}
                    {userdetails.sip_login_id !== detailPage.sip_id && <URButton className="urButton buttonredbdr buttonSm deletebtn" name='Delete' onClick={deleteMeeting} />}</>}
                  <URButton className='urButton cancelMeetingNobdr buttonSm deletebtn' name="Cancel Meeting"
                      onClick={cancelMeeting}></URButton>
                 
                  </>}
              </div>
              {(userdetails.sip_login_id === detailPage.sip_id)?<div>
                <URButton className='urButton buttonWhite buttonMd right8' name="Edit" onClick={editMeeting}></URButton>
                
              </div>:""}
              
          </div>}
          {(previousMeetingArray.includes(detailPage.status) || detailPage.status === "Join") &&   <div className={styles.previousmeetingsec}>
              <div>
              {(userdetails.sip_login_id === detailPage.sip_id && detailPage.status !== "Start") && <URButton className='urButton buttonBlue buttonSm right8 editbuttoning editBtnright'name={"Save as Template"} onClick={saveAsTemplate}></URButton>}
              </div>
              <div>
             {((userdetails.sip_login_id !== detailPage.sip_id || userdetails.sip_login_id === detailPage.sip_id) && detailPage.status!=="Ongoing Meeting" ) &&  <URButton className="urButton cancelMeetingNobdr" name='Delete Meeting' onClick={deleteMeeting}/>}
              </div>
          </div>} </>}
          
          {currentWindowState === "templateDetails" && <><URButton className='urButton buttonBlue buttonSm right8'
            name={"Use This Template"} onClick={useThisTemplate}></URButton>
            <URButton className="urButton buttonredbdr buttonSm deletebtn" name='Delete' onClick={deleteTemplate}/></>
          }


        </div>
      </div>
      <Modal visible={getData.useTemplateModal} title="Save as template"
        centered
        onOk={saveAsTemplateConfirm}
        onCancel={closeModal}
        cancelText="Cancel"
        okText="Save"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup savetempltop">
        <div className={styles.hostconSec}>
          <div className={`topsubhederchange ${styles.scheduleTitle}`}>
            <label className="topheadertxt">Template Title</label>
            <URInput placeHolder="Enter meeting title" name="" className="inputcustomBox"
              value={getData.inputText} onChange={enterTitle} />
          </div>
        </div>
      </Modal>
      <Modal title="Cancel Meeting ?"
        centered
        visible={getData.isCancelModal}
        onOk={cancelMeetingConfirm}
        onCancel={closeModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
           Are you sure want to cancel the meeting?
      </Modal>
      <Modal title="Delete Meeting ?"
        centered
        visible={getData.isDeleteModal}
        onOk={deleteMeetingConfirm}
        onCancel={closeModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
           Are you sure want to delete the meeting?
      </Modal>
      <Modal title="Delete this Saved Template?"
        centered
        visible={getData.deleteTemplateModal}
        onOk={deleteTemplateConfirm}
        onCancel={closeModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
           This template will be permanently deleted from the list.
      </Modal>
    </>
  );
};

